import { urlencoded } from "body-parser";
import classNames from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GatewayIntegrationFunctionsMobile } from "../gateway-integration-functions-mobile";

import "./styles.less";
const isWindow = () => typeof window !== "undefined";
const isDocument = () => typeof document !== "undefined";
export const GatewayIntegrationFunctions = () => {
  const { t } = useTranslation();
  //
  const bannerList = [
    {
      iconUrl: "//files.authing.co/authing-website/gateway-life-cycle-icon.png",
      title: t("gateway.functions.item1.title"),
      content: t("gateway.functions.item1.descript"),
      backgroundImg:
        "//files.authing.co/authing-website/gateway-life-cycle-bg.png",
      imgUrl:
        "//files.authing.co/authing-website/gateway-life-cycle-img-new.png",
    },
    // {
    //   iconUrl: "//files.authing.co/authing-website/gateway-flow-icon.png",
    //   title: t("gateway.functions.item2.title"),
    //   content: t("gateway.functions.item2.descript"),
    //   backgroundImg: "//files.authing.co/authing-website/gateway-flow-bg.png",
    //   imgUrl: "//files.authing.co/authing-website/gateway-flow-img-new.png",
    // },
    {
      iconUrl: "//files.authing.co/authing-website/gateway-warning-icon.png",
      title: t("gateway.functions.item3.title"),
      content: t("gateway.functions.item3.descript"),
      backgroundImg:
        "//files.authing.co/authing-website/gateway-warning-bg.png",
      imgUrl: "//files.authing.co/authing-website/gateway-warning-img-new.png",
    },
    {
      iconUrl: "//files.authing.co/authing-website/gateway-access-icon.png",
      title: t("gateway.functions.item4.title"),
      content: t("gateway.functions.item4.descript"),
      backgroundImg: "//files.authing.co/authing-website/gateway-access-bg.png",
      imgUrl: "//files.authing.co/authing-website/gateway-access-img-new.png",
    },
    {
      iconUrl: "//files.authing.co/authing-website/gateway-log-icon.png",
      title: t("gateway.functions.item5.title"),
      content: t("gateway.functions.item5.descript"),
      backgroundImg: "//files.authing.co/authing-website/gateway-log-bg.png",
      imgUrl:
        "//files.authing.co/authing-website/gateway-access-log-img-new.png",
    },
  ];
  const [topValue, setTopValue] = useState("0px");
  const [bottomValue, setBottomValue] = useState();
  const [scrollTop, setScrollTop] = useState(0);
  const [bannerIndex, setBannerIndex] = useState(0);
  const scrollHandler = useCallback(() => {
    if (isDocument()) {
      const chrildElement =
        isDocument() && document.querySelector(".bannerBox-right-chrild");
      const documentScrollTop =
        (isDocument() && document.body.scrollTop) ||
        document.documentElement.scrollTop;
      const selfHeight =
        isWindow() &&
        Number(window.getComputedStyle(chrildElement).height.split("px")[0]);
      if (topValue < documentScrollTop) {
        const index = Math.round((documentScrollTop - topValue) / selfHeight);
        if (index < bannerList.length) {
          setBannerIndex(index);
        }
      }
      setScrollTop(documentScrollTop);
    }
  });
  useEffect(() => {
    scrollHandler();
  }, [scrollHandler]);
  useEffect(() => {
    isWindow() && window.addEventListener("scroll", scrollHandler);
    return () => {
      isWindow() && window.removeEventListener("scroll", scrollHandler);
    };
  }, [scrollHandler]);
  useEffect(() => {
    if (isWindow()) {
      const bannerBox = document.getElementById("bannerBox");
      if (bannerBox) {
        setTopValue(bannerBox.offsetTop);
        setBottomValue(
          isWindow() &&
            Number(window.getComputedStyle(bannerBox).height.split("p")[0]) +
              topValue,
          +"px"
        );
      }
    }
  }, [scrollHandler, topValue]);
  const clientHeight =
    (isDocument() && document.documentElement.clientHeight) || "";
  const cls = classNames({
    "bannerBox-left": true,
    fixed:
      scrollTop + 80 > topValue && scrollTop + clientHeight < bottomValue
        ? true
        : false,
    bottom: scrollTop + clientHeight > bottomValue ? true : false,
  });
  const clsbg = classNames({
    "bannerBox-right-bg": true,
    fixed:
      scrollTop + 80 > topValue && scrollTop + clientHeight < bottomValue
        ? true
        : false,
    bottom: scrollTop + clientHeight > bottomValue ? true : false,
  });
  const gatewayFunctionsRender = () => {
    return (
      <div className="gateway-functions">
        <div className="functions-title">{t("gateway.functions.title")}</div>
        <div className="gateway-functions-box">
          <div className="banner-connection" id="bannerBox">
            <div className={cls}>
              <div className="index-box">
                {bannerList.map((item, index) => {
                  return <li className={bannerIndex == index ? "li" : ""}></li>;
                })}
              </div>
              <div className="info-box">
                {bannerList.map((item, index) => {
                  return (
                    <div
                      className="info-box-item"
                      key={"info-box" + index}
                      style={
                        bannerIndex === index
                          ? { display: "block" }
                          : { display: "none" }
                      }
                    >
                      <img src={item.iconUrl} alt="authing" />
                      <div className="info-box-item-title">{item.title}</div>
                      <div className="info-box-item-content">
                        {item.content}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="bannerBox-list">
              {bannerList.map((item, index) => {
                return (
                  <div key={"bannerBox-right" + index}>
                    <div className="bannerBox-right">
                      <div className="bannerBox-right-chrild">
                        <img
                          src={item.imgUrl}
                          alt="authing"
                          style={{ zIndex: "2" }}
                        />
                      </div>
                    </div>
                    <div
                      className={
                        index === bannerIndex ? `${clsbg} bg${index}` : ""
                      }
                      style={{
                        backgroundSize: "contain",
                        zIndex: "1",
                        backgroundRepeat: "no-repeat",
                      }}
                    ></div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <GatewayIntegrationFunctionsMobile />
      {/* <MobileFooter menuList={menuList} communityLink={communityLink} /> */}
      {gatewayFunctionsRender()}
    </>
  );
};
